import { useState } from 'react';
import styled from 'styled-components/macro';
import { Box, Button, Flex } from 'components/ui';
import { Redirect } from 'react-router';
import { DROP } from 'components/common';
import genesisImg from 'img/lp-genesis.png';
import enigmaImg from 'img/lp-enigma.png';

const Wrapper = styled(Flex)`
  width: 100%;
  background-color: black;
`;

const DropBox = styled(Box)<any>`
  background-image: url(${props => props.bg});
  background-repeat: no-repeat;
  background-size: auto;
  background-position: right bottom;
  border-right: 1px solid white;
  height: 100%;
  min-height: 340px;
  border-bottom: 1px solid white;
  color: white;
  min-height: 320px;
`;

const GenesisEnigmaSection = () => {
  const [drop, setDrop] = useState<DROP | undefined>();
  const [redirect, setRedirect] = useState<boolean>(false);

  if (redirect) {
    return <Redirect to={`/${drop}`} push />;
  }

  return (
    <Wrapper
      flexDirection={['column', 'row', 'row']}
    >
      <DropBox
        bg={genesisImg}
        width={['100%', '50%', '50%']}
        padding={['40px 16px', '40px']}
      >
        <h2>GENESIS</h2>
        <Box mb={3} maxWidth="420px">
          Explore EulerBeats Genesis - first of its kind, limited edition, algorithmically generated art + music based on the Euler number and Euler’s totient function Phi.
        </Box>
        <Button
          outlined
          onClick={() => {
            setDrop(DROP.genesis);
            setRedirect(true);
          }}
        >
          Buy now
        </Button>
      </DropBox>
      <DropBox
        bg={enigmaImg}
        width={['100%', '50%', '50%']}
        padding={['40px 16px', '40px']}
      >
        <h2>ENIGMA</h2>
        <Box mb={3} maxWidth="420px">
          Explore EulerBeats Engima - a re-imagined music + art interpretation of Euler’s totient function, completing the second side of the Euler Record. 
        </Box>
        <Button
          outlined
          onClick={() => {
            setDrop(DROP.enigma);
            setRedirect(true);
          }}
        >
          Buy now
        </Button>
      </DropBox>
    </Wrapper>
  )
}

export default GenesisEnigmaSection;
